import styled from 'styled-components';
import { PaginatorStyled } from '../PaginatorStyled';
import { rem } from 'polished';

export const PaginatorStyledDS = styled(PaginatorStyled)`
    .pagination {
        svg {
            width: ${rem(18)};
            height: ${rem(14)};
        }
        li {
            &.previous {
                svg {
                    transform: rotate(90deg);
                }
            }
            &.next {
                svg {
                    transform: rotate(-90deg);
                }
            }
            a {
                color: ${({ theme }) => theme.colors.black};
                border: none;
                width: ${rem('34px')};
                text-align: center;
                margin: 0 ${rem('6px')};
                background: transparent;
                padding: ${rem('6px')};
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
            &.active a,
            &:hover a {
                background-color: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.black};
                text-decoration: underline;
            }
        }
    }
`;
